{
    "v": "4.8.0",
    "meta": {
        "g": "LottieFiles AE 1.1.0",
        "a": "",
        "k": "",
        "d": "",
        "tc": ""
    },
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 143.000005824509,
    "w": 1000,
    "h": 1000,
    "nm": "Stretch comp",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Torso/Stretch Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167
                                ],
                                "y": [
                                    0.167
                                ]
                            },
                            "t": 0,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 30,
                            "s": [
                                5
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.252
                                ],
                                "y": [
                                    0.002
                                ]
                            },
                            "t": 81,
                            "s": [
                                5
                            ]
                        },
                        {
                            "t": 143.000005824509,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "s": true,
                    "x": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.455
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 0,
                                "s": [
                                    388
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 29.535,
                                "s": [
                                    374
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        0.991
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 54,
                                "s": [
                                    388
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.469
                                    ],
                                    "y": [
                                        0.992
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.286
                                    ],
                                    "y": [
                                        -0.017
                                    ]
                                },
                                "t": 81,
                                "s": [
                                    374
                                ]
                            },
                            {
                                "t": 143.000005824509,
                                "s": [
                                    388
                                ]
                            }
                        ],
                        "ix": 3
                    },
                    "y": {
                        "a": 1,
                        "k": [
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.377
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 0,
                                "s": [
                                    334
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 30,
                                "s": [
                                    365
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.667
                                    ],
                                    "y": [
                                        1.05
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.333
                                    ],
                                    "y": [
                                        0
                                    ]
                                },
                                "t": 54,
                                "s": [
                                    336.069
                                ]
                            },
                            {
                                "i": {
                                    "x": [
                                        0.367
                                    ],
                                    "y": [
                                        1.092
                                    ]
                                },
                                "o": {
                                    "x": [
                                        0.267
                                    ],
                                    "y": [
                                        0.086
                                    ]
                                },
                                "t": 81,
                                "s": [
                                    365
                                ]
                            },
                            {
                                "t": 143.000005824509,
                                "s": [
                                    334
                                ]
                            }
                        ],
                        "ix": 4
                    }
                },
                "a": {
                    "a": 0,
                    "k": [
                        368,
                        334,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0.318,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.293,
                                            -0.176
                                        ],
                                        [
                                            0.416,
                                            -0.416
                                        ],
                                        [
                                            0.172,
                                            -0.429
                                        ],
                                        [
                                            -0.318,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.293,
                                            0.175
                                        ],
                                        [
                                            -0.417,
                                            0.415
                                        ],
                                        [
                                            -0.172,
                                            0.43
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.362,
                                            0
                                        ],
                                        [
                                            -0.505,
                                            0.303
                                        ],
                                        [
                                            -0.323,
                                            0.322
                                        ],
                                        [
                                            -0.064,
                                            0.162
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.363,
                                            0
                                        ],
                                        [
                                            0.505,
                                            -0.304
                                        ],
                                        [
                                            0.323,
                                            -0.322
                                        ],
                                        [
                                            0.064,
                                            -0.162
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4.877,
                                            -1.58
                                        ],
                                        [
                                            -1.617,
                                            -1.58
                                        ],
                                        [
                                            -2.678,
                                            -1.166
                                        ],
                                        [
                                            -4.104,
                                            -0.05
                                        ],
                                        [
                                            -4.999,
                                            1.067
                                        ],
                                        [
                                            -4.877,
                                            1.58
                                        ],
                                        [
                                            1.616,
                                            1.58
                                        ],
                                        [
                                            2.678,
                                            1.167
                                        ],
                                        [
                                            4.104,
                                            0.051
                                        ],
                                        [
                                            4.999,
                                            -1.067
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    330.475,
                                    287.908
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0.69,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.591,
                                            -0.59
                                        ],
                                        [
                                            -0.69,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.59,
                                            0.589
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.895,
                                            0
                                        ],
                                        [
                                            -0.133,
                                            0.133
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.895,
                                            0
                                        ],
                                        [
                                            0.133,
                                            -0.134
                                        ]
                                    ],
                                    "v": [
                                        [
                                            7.27,
                                            -1.58
                                        ],
                                        [
                                            -4.008,
                                            -1.58
                                        ],
                                        [
                                            -6.496,
                                            -0.05
                                        ],
                                        [
                                            -7.27,
                                            1.58
                                        ],
                                        [
                                            4.009,
                                            1.58
                                        ],
                                        [
                                            6.496,
                                            0.051
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    327.201,
                                    279.849
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0.318,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.293,
                                            -0.176
                                        ],
                                        [
                                            0.416,
                                            -0.416
                                        ],
                                        [
                                            0.172,
                                            -0.429
                                        ],
                                        [
                                            -0.318,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.293,
                                            0.175
                                        ],
                                        [
                                            -0.417,
                                            0.415
                                        ],
                                        [
                                            -0.172,
                                            0.43
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.362,
                                            0
                                        ],
                                        [
                                            -0.506,
                                            0.303
                                        ],
                                        [
                                            -0.323,
                                            0.322
                                        ],
                                        [
                                            -0.064,
                                            0.162
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.363,
                                            0
                                        ],
                                        [
                                            0.505,
                                            -0.304
                                        ],
                                        [
                                            0.323,
                                            -0.322
                                        ],
                                        [
                                            0.064,
                                            -0.162
                                        ]
                                    ],
                                    "v": [
                                        [
                                            4.022,
                                            -1.58
                                        ],
                                        [
                                            -0.763,
                                            -1.58
                                        ],
                                        [
                                            -1.824,
                                            -1.166
                                        ],
                                        [
                                            -3.25,
                                            -0.05
                                        ],
                                        [
                                            -4.145,
                                            1.067
                                        ],
                                        [
                                            -4.023,
                                            1.58
                                        ],
                                        [
                                            0.762,
                                            1.58
                                        ],
                                        [
                                            1.823,
                                            1.167
                                        ],
                                        [
                                            3.249,
                                            0.051
                                        ],
                                        [
                                            4.145,
                                            -1.067
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    333.865,
                                    272.87
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            1.091,
                                            0.203
                                        ],
                                        [
                                            2.163,
                                            -2.195
                                        ],
                                        [
                                            -1.999,
                                            -1.818
                                        ],
                                        [
                                            -0.843,
                                            -4.592
                                        ],
                                        [
                                            2.02,
                                            0.58
                                        ],
                                        [
                                            0.938,
                                            2.026
                                        ],
                                        [
                                            -0.621,
                                            -1.342
                                        ],
                                        [
                                            -3.674,
                                            5.643
                                        ],
                                        [
                                            2.452,
                                            2.091
                                        ],
                                        [
                                            1.588,
                                            0.657
                                        ],
                                        [
                                            0.118,
                                            0.874
                                        ],
                                        [
                                            -1.184,
                                            -0.22
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -2.93,
                                            -0.546
                                        ],
                                        [
                                            -1.614,
                                            1.64
                                        ],
                                        [
                                            2.758,
                                            2.509
                                        ],
                                        [
                                            0.529,
                                            2.879
                                        ],
                                        [
                                            -2.226,
                                            -0.64
                                        ],
                                        [
                                            -0.332,
                                            -0.718
                                        ],
                                        [
                                            3.103,
                                            6.703
                                        ],
                                        [
                                            1.76,
                                            -2.704
                                        ],
                                        [
                                            -1.327,
                                            -1.131
                                        ],
                                        [
                                            -0.6,
                                            -0.248
                                        ],
                                        [
                                            -0.184,
                                            -1.37
                                        ],
                                        [
                                            1.284,
                                            0.24
                                        ]
                                    ],
                                    "v": [
                                        [
                                            3.294,
                                            -11.143
                                        ],
                                        [
                                            -4.2,
                                            -9.225
                                        ],
                                        [
                                            -4.991,
                                            -3.365
                                        ],
                                        [
                                            4.571,
                                            3.352
                                        ],
                                        [
                                            -0.333,
                                            5.998
                                        ],
                                        [
                                            -4.971,
                                            1.665
                                        ],
                                        [
                                            -8.292,
                                            4.986
                                        ],
                                        [
                                            7.153,
                                            5.007
                                        ],
                                        [
                                            5.875,
                                            -2.894
                                        ],
                                        [
                                            1.254,
                                            -5.282
                                        ],
                                        [
                                            -1.976,
                                            -6.998
                                        ],
                                        [
                                            0.409,
                                            -7.623
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    347.496,
                                    282.254
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        33.363,
                                                        -16.44
                                                    ],
                                                    [
                                                        26.662,
                                                        28.423
                                                    ],
                                                    [
                                                        -21,
                                                        32
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.769,
                                                        8.166
                                                    ],
                                                    [
                                                        -69,
                                                        34
                                                    ],
                                                    [
                                                        -20.777,
                                                        -22.15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        79.174,
                                                        -41.512
                                                    ],
                                                    [
                                                        89.207,
                                                        49.512
                                                    ],
                                                    [
                                                        -101.793,
                                                        43.512
                                                    ],
                                                    [
                                                        -62.826,
                                                        -83.512
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        33.363,
                                                        -16.44
                                                    ],
                                                    [
                                                        26.662,
                                                        28.423
                                                    ],
                                                    [
                                                        -21,
                                                        32
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -10.952,
                                                        27.733
                                                    ],
                                                    [
                                                        -69,
                                                        34
                                                    ],
                                                    [
                                                        -20.777,
                                                        -22.15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        85.675,
                                                        -41.282
                                                    ],
                                                    [
                                                        89.207,
                                                        49.512
                                                    ],
                                                    [
                                                        -101.793,
                                                        43.512
                                                    ],
                                                    [
                                                        -62.826,
                                                        -83.512
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 53,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        33.363,
                                                        -16.44
                                                    ],
                                                    [
                                                        26.662,
                                                        28.423
                                                    ],
                                                    [
                                                        -21,
                                                        32
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.769,
                                                        8.166
                                                    ],
                                                    [
                                                        -69,
                                                        34
                                                    ],
                                                    [
                                                        -20.777,
                                                        -22.15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        79.174,
                                                        -41.512
                                                    ],
                                                    [
                                                        89.207,
                                                        49.512
                                                    ],
                                                    [
                                                        -101.793,
                                                        43.512
                                                    ],
                                                    [
                                                        -62.826,
                                                        -83.512
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        33.363,
                                                        -16.44
                                                    ],
                                                    [
                                                        26.662,
                                                        28.423
                                                    ],
                                                    [
                                                        -21,
                                                        32
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -10.952,
                                                        27.733
                                                    ],
                                                    [
                                                        -69,
                                                        34
                                                    ],
                                                    [
                                                        -20.777,
                                                        -22.15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        85.675,
                                                        -41.282
                                                    ],
                                                    [
                                                        89.207,
                                                        49.512
                                                    ],
                                                    [
                                                        -101.793,
                                                        43.512
                                                    ],
                                                    [
                                                        -62.826,
                                                        -83.512
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 139.000005661586,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        33.363,
                                                        -16.44
                                                    ],
                                                    [
                                                        26.662,
                                                        28.423
                                                    ],
                                                    [
                                                        -21,
                                                        32
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.769,
                                                        8.166
                                                    ],
                                                    [
                                                        -69,
                                                        34
                                                    ],
                                                    [
                                                        -20.777,
                                                        -22.15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        79.174,
                                                        -41.512
                                                    ],
                                                    [
                                                        89.207,
                                                        49.512
                                                    ],
                                                    [
                                                        -101.793,
                                                        43.512
                                                    ],
                                                    [
                                                        -62.826,
                                                        -83.512
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.462745127958,
                                    0.701960784314,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 t-shirt",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    365.293,
                                    343.988
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -17.772,
                                                        6.516
                                                    ],
                                                    [
                                                        -36.38,
                                                        25.793
                                                    ],
                                                    [
                                                        -18.714,
                                                        -20.732
                                                    ],
                                                    [
                                                        -13.727,
                                                        -4.673
                                                    ],
                                                    [
                                                        -37.58,
                                                        10.38
                                                    ],
                                                    [
                                                        -20.014,
                                                        -16.333
                                                    ],
                                                    [
                                                        21.089,
                                                        6.947
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -14.384,
                                                        -21.771
                                                    ],
                                                    [
                                                        30,
                                                        -11
                                                    ],
                                                    [
                                                        15.599,
                                                        -11.06
                                                    ],
                                                    [
                                                        28.493,
                                                        31.566
                                                    ],
                                                    [
                                                        19.527,
                                                        6.649
                                                    ],
                                                    [
                                                        13.877,
                                                        -3.833
                                                    ],
                                                    [
                                                        21.466,
                                                        17.519
                                                    ],
                                                    [
                                                        -11.569,
                                                        -3.811
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -101.847,
                                                        61.742
                                                    ],
                                                    [
                                                        -154.847,
                                                        -37.258
                                                    ],
                                                    [
                                                        -85.413,
                                                        -75.675
                                                    ],
                                                    [
                                                        -11.6,
                                                        -41.003
                                                    ],
                                                    [
                                                        27.416,
                                                        19.028
                                                    ],
                                                    [
                                                        99.276,
                                                        -15.425
                                                    ],
                                                    [
                                                        151.153,
                                                        15.742
                                                    ],
                                                    [
                                                        88.153,
                                                        102.742
                                                    ],
                                                    [
                                                        73.344,
                                                        56.325
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 29,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -28.848,
                                                        7.735
                                                    ],
                                                    [
                                                        -26.434,
                                                        35.917
                                                    ],
                                                    [
                                                        -13.627,
                                                        -25.411
                                                    ],
                                                    [
                                                        -13.727,
                                                        -4.673
                                                    ],
                                                    [
                                                        -37.58,
                                                        10.38
                                                    ],
                                                    [
                                                        -20.014,
                                                        -16.333
                                                    ],
                                                    [
                                                        21.089,
                                                        6.947
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -14.384,
                                                        -21.771
                                                    ],
                                                    [
                                                        30.863,
                                                        -8.276
                                                    ],
                                                    [
                                                        11.418,
                                                        -15.514
                                                    ],
                                                    [
                                                        20.096,
                                                        37.475
                                                    ],
                                                    [
                                                        19.527,
                                                        6.649
                                                    ],
                                                    [
                                                        13.877,
                                                        -3.833
                                                    ],
                                                    [
                                                        21.466,
                                                        17.519
                                                    ],
                                                    [
                                                        -11.569,
                                                        -3.811
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -101.847,
                                                        61.742
                                                    ],
                                                    [
                                                        -143.888,
                                                        -38.207
                                                    ],
                                                    [
                                                        -52.045,
                                                        -89.672
                                                    ],
                                                    [
                                                        -3.1,
                                                        -42.003
                                                    ],
                                                    [
                                                        27.416,
                                                        19.028
                                                    ],
                                                    [
                                                        99.276,
                                                        -15.425
                                                    ],
                                                    [
                                                        151.153,
                                                        15.742
                                                    ],
                                                    [
                                                        88.153,
                                                        102.742
                                                    ],
                                                    [
                                                        73.344,
                                                        56.325
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 53,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -17.772,
                                                        6.516
                                                    ],
                                                    [
                                                        -26.434,
                                                        35.917
                                                    ],
                                                    [
                                                        -13.627,
                                                        -25.411
                                                    ],
                                                    [
                                                        -13.727,
                                                        -4.673
                                                    ],
                                                    [
                                                        -37.58,
                                                        10.38
                                                    ],
                                                    [
                                                        -20.014,
                                                        -16.333
                                                    ],
                                                    [
                                                        21.089,
                                                        6.947
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -14.384,
                                                        -21.771
                                                    ],
                                                    [
                                                        30,
                                                        -11
                                                    ],
                                                    [
                                                        11.418,
                                                        -15.514
                                                    ],
                                                    [
                                                        20.096,
                                                        37.475
                                                    ],
                                                    [
                                                        19.527,
                                                        6.649
                                                    ],
                                                    [
                                                        13.877,
                                                        -3.833
                                                    ],
                                                    [
                                                        21.466,
                                                        17.519
                                                    ],
                                                    [
                                                        -11.569,
                                                        -3.811
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -101.847,
                                                        61.742
                                                    ],
                                                    [
                                                        -154.847,
                                                        -37.258
                                                    ],
                                                    [
                                                        -63.413,
                                                        -84.175
                                                    ],
                                                    [
                                                        -3.1,
                                                        -42.003
                                                    ],
                                                    [
                                                        27.416,
                                                        19.028
                                                    ],
                                                    [
                                                        99.276,
                                                        -15.425
                                                    ],
                                                    [
                                                        151.153,
                                                        15.742
                                                    ],
                                                    [
                                                        88.153,
                                                        102.742
                                                    ],
                                                    [
                                                        73.344,
                                                        56.325
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -28.848,
                                                        7.735
                                                    ],
                                                    [
                                                        -26.434,
                                                        35.917
                                                    ],
                                                    [
                                                        -13.627,
                                                        -25.411
                                                    ],
                                                    [
                                                        -13.727,
                                                        -4.673
                                                    ],
                                                    [
                                                        -37.58,
                                                        10.38
                                                    ],
                                                    [
                                                        -20.014,
                                                        -16.333
                                                    ],
                                                    [
                                                        21.089,
                                                        6.947
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -14.384,
                                                        -21.771
                                                    ],
                                                    [
                                                        30.863,
                                                        -8.276
                                                    ],
                                                    [
                                                        11.418,
                                                        -15.514
                                                    ],
                                                    [
                                                        20.096,
                                                        37.475
                                                    ],
                                                    [
                                                        19.527,
                                                        6.649
                                                    ],
                                                    [
                                                        13.877,
                                                        -3.833
                                                    ],
                                                    [
                                                        21.466,
                                                        17.519
                                                    ],
                                                    [
                                                        -11.569,
                                                        -3.811
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -101.847,
                                                        61.742
                                                    ],
                                                    [
                                                        -143.888,
                                                        -38.207
                                                    ],
                                                    [
                                                        -52.045,
                                                        -89.672
                                                    ],
                                                    [
                                                        -3.1,
                                                        -42.003
                                                    ],
                                                    [
                                                        27.416,
                                                        19.028
                                                    ],
                                                    [
                                                        99.276,
                                                        -15.425
                                                    ],
                                                    [
                                                        151.153,
                                                        15.742
                                                    ],
                                                    [
                                                        88.153,
                                                        102.742
                                                    ],
                                                    [
                                                        73.344,
                                                        56.325
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 140.000005702317,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -17.772,
                                                        6.516
                                                    ],
                                                    [
                                                        -36.38,
                                                        25.793
                                                    ],
                                                    [
                                                        -18.714,
                                                        -20.732
                                                    ],
                                                    [
                                                        -13.727,
                                                        -4.673
                                                    ],
                                                    [
                                                        -37.58,
                                                        10.38
                                                    ],
                                                    [
                                                        -20.014,
                                                        -16.333
                                                    ],
                                                    [
                                                        21.089,
                                                        6.947
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -14.384,
                                                        -21.771
                                                    ],
                                                    [
                                                        30,
                                                        -11
                                                    ],
                                                    [
                                                        15.599,
                                                        -11.06
                                                    ],
                                                    [
                                                        28.493,
                                                        31.566
                                                    ],
                                                    [
                                                        19.527,
                                                        6.649
                                                    ],
                                                    [
                                                        13.877,
                                                        -3.833
                                                    ],
                                                    [
                                                        21.466,
                                                        17.519
                                                    ],
                                                    [
                                                        -11.569,
                                                        -3.811
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -101.847,
                                                        61.742
                                                    ],
                                                    [
                                                        -154.847,
                                                        -37.258
                                                    ],
                                                    [
                                                        -85.413,
                                                        -75.675
                                                    ],
                                                    [
                                                        -11.6,
                                                        -41.003
                                                    ],
                                                    [
                                                        27.416,
                                                        19.028
                                                    ],
                                                    [
                                                        99.276,
                                                        -15.425
                                                    ],
                                                    [
                                                        151.153,
                                                        15.742
                                                    ],
                                                    [
                                                        88.153,
                                                        102.742
                                                    ],
                                                    [
                                                        73.344,
                                                        56.325
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.462745127958,
                                    0.701960784314,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 öö",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    376.314,
                                    263.735
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Head/Stretch Outlines",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                -5
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 29,
                            "s": [
                                3
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 55,
                            "s": [
                                -5
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                3
                            ]
                        },
                        {
                            "t": 143.000005824509,
                            "s": [
                                -5
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        379,
                        309,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        379,
                        302,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.147,
                                            0.93
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.978,
                                            -3.223
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            5.629,
                                            3.613
                                        ],
                                        [
                                            1.29,
                                            -0.391
                                        ],
                                        [
                                            -5.629,
                                            -3.369
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.415686304429,
                                    0.231372563979,
                                    0.917647118662,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 bb",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    432.95,
                                    221.472
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.323,
                                            -0.655
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.589,
                                            2.269
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -5.522,
                                            -3.658
                                        ],
                                        [
                                            -0.073,
                                            -1.386
                                        ],
                                        [
                                            5.523,
                                            3.658
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.415686304429,
                                    0.231372563979,
                                    0.917647118662,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 aa",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    412.951,
                                    208.594
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            2.176,
                                            1.436
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.437,
                                            2.175
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.175,
                                            -1.436
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.436,
                                            -2.176
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.175,
                                            -1.436
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.436,
                                            -2.175
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.175,
                                            1.436
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.436,
                                            2.176
                                        ]
                                    ],
                                    "v": [
                                        [
                                            25.815,
                                            26
                                        ],
                                        [
                                            -34.053,
                                            -13.52
                                        ],
                                        [
                                            -35.392,
                                            -20.059
                                        ],
                                        [
                                            -32.354,
                                            -24.661
                                        ],
                                        [
                                            -25.816,
                                            -26
                                        ],
                                        [
                                            34.053,
                                            13.521
                                        ],
                                        [
                                            35.392,
                                            20.06
                                        ],
                                        [
                                            32.354,
                                            24.661
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0.400000029919,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 ee",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    436.925,
                                    190.614
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            15.026,
                                            4.207
                                        ],
                                        [
                                            -13.718,
                                            22.115
                                        ],
                                        [
                                            -24.057,
                                            -17.183
                                        ],
                                        [
                                            0.612,
                                            -2.701
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -28.639,
                                            -8.019
                                        ],
                                        [
                                            9.956,
                                            -16.048
                                        ],
                                        [
                                            13.982,
                                            9.988
                                        ],
                                        [
                                            -4.691,
                                            20.679
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -4.33,
                                            36.279
                                        ],
                                        [
                                            -21.514,
                                            -24.438
                                        ],
                                        [
                                            16.631,
                                            -21.021
                                        ],
                                        [
                                            34.62,
                                            -2.672
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    425.835,
                                    207.497
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            23.555,
                                            37.502
                                        ],
                                        [
                                            -31.445,
                                            10.502
                                        ],
                                        [
                                            1.445,
                                            -37.502
                                        ],
                                        [
                                            31.445,
                                            -20.502
                                        ],
                                        [
                                            25.555,
                                            17.502
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    399.912,
                                    263.975
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 1,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -3.966,
                                                        2.062
                                                    ],
                                                    [
                                                        -6.834,
                                                        6.177
                                                    ],
                                                    [
                                                        -4.687,
                                                        8.038
                                                    ],
                                                    [
                                                        -6.284,
                                                        3.528
                                                    ],
                                                    [
                                                        -17.363,
                                                        -5.997
                                                    ],
                                                    [
                                                        -9.794,
                                                        -5.121
                                                    ],
                                                    [
                                                        -5.603,
                                                        -10.833
                                                    ],
                                                    [
                                                        5.162,
                                                        -9.219
                                                    ],
                                                    [
                                                        12.736,
                                                        -9.547
                                                    ],
                                                    [
                                                        3.115,
                                                        -9.442
                                                    ],
                                                    [
                                                        1.666,
                                                        -5.388
                                                    ],
                                                    [
                                                        21.679,
                                                        5.9
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.195,
                                                        -4.03
                                                    ],
                                                    [
                                                        14.041,
                                                        -12.69
                                                    ],
                                                    [
                                                        8.322,
                                                        -14.271
                                                    ],
                                                    [
                                                        4.758,
                                                        -2.671
                                                    ],
                                                    [
                                                        13.683,
                                                        4.726
                                                    ],
                                                    [
                                                        4.063,
                                                        2.125
                                                    ],
                                                    [
                                                        1.624,
                                                        3.14
                                                    ],
                                                    [
                                                        -4.76,
                                                        8.5
                                                    ],
                                                    [
                                                        -12.605,
                                                        9.448
                                                    ],
                                                    [
                                                        -2.879,
                                                        8.788
                                                    ],
                                                    [
                                                        -6.537,
                                                        21.316
                                                    ],
                                                    [
                                                        -29.128,
                                                        -7.927
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -70.098,
                                                        -1.115
                                                    ],
                                                    [
                                                        -36.098,
                                                        -30.115
                                                    ],
                                                    [
                                                        -12.098,
                                                        -50.115
                                                    ],
                                                    [
                                                        -6.098,
                                                        -82.115
                                                    ],
                                                    [
                                                        20.902,
                                                        -71.115
                                                    ],
                                                    [
                                                        46.902,
                                                        -64.115
                                                    ],
                                                    [
                                                        65.902,
                                                        -46.115
                                                    ],
                                                    [
                                                        68.902,
                                                        -21.115
                                                    ],
                                                    [
                                                        42.902,
                                                        -8.115
                                                    ],
                                                    [
                                                        22.125,
                                                        25.885
                                                    ],
                                                    [
                                                        17.173,
                                                        70.633
                                                    ],
                                                    [
                                                        -39.098,
                                                        78.885
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 28,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -3.966,
                                                        2.062
                                                    ],
                                                    [
                                                        -13.25,
                                                        13.49
                                                    ],
                                                    [
                                                        -4.687,
                                                        8.038
                                                    ],
                                                    [
                                                        -6.284,
                                                        3.528
                                                    ],
                                                    [
                                                        -17.363,
                                                        -5.997
                                                    ],
                                                    [
                                                        -9.794,
                                                        -5.121
                                                    ],
                                                    [
                                                        -5.603,
                                                        -10.833
                                                    ],
                                                    [
                                                        5.162,
                                                        -9.219
                                                    ],
                                                    [
                                                        12.736,
                                                        -9.547
                                                    ],
                                                    [
                                                        -0.871,
                                                        -9.874
                                                    ],
                                                    [
                                                        -0.722,
                                                        -5.574
                                                    ],
                                                    [
                                                        21.679,
                                                        5.9
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -0.413,
                                                        -10.672
                                                    ],
                                                    [
                                                        13.262,
                                                        -13.502
                                                    ],
                                                    [
                                                        8.322,
                                                        -14.271
                                                    ],
                                                    [
                                                        4.758,
                                                        -2.671
                                                    ],
                                                    [
                                                        13.683,
                                                        4.726
                                                    ],
                                                    [
                                                        4.063,
                                                        2.125
                                                    ],
                                                    [
                                                        1.624,
                                                        3.14
                                                    ],
                                                    [
                                                        -4.76,
                                                        8.5
                                                    ],
                                                    [
                                                        -12.605,
                                                        9.448
                                                    ],
                                                    [
                                                        1.133,
                                                        12.317
                                                    ],
                                                    [
                                                        2.727,
                                                        21.14
                                                    ],
                                                    [
                                                        -29.128,
                                                        -7.927
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -60.168,
                                                        15.092
                                                    ],
                                                    [
                                                        -36.098,
                                                        -30.115
                                                    ],
                                                    [
                                                        -12.098,
                                                        -50.115
                                                    ],
                                                    [
                                                        -7.292,
                                                        -78.499
                                                    ],
                                                    [
                                                        20.902,
                                                        -71.115
                                                    ],
                                                    [
                                                        46.902,
                                                        -64.115
                                                    ],
                                                    [
                                                        65.902,
                                                        -46.115
                                                    ],
                                                    [
                                                        68.902,
                                                        -21.115
                                                    ],
                                                    [
                                                        42.902,
                                                        -8.115
                                                    ],
                                                    [
                                                        28.529,
                                                        27.297
                                                    ],
                                                    [
                                                        37.748,
                                                        73.792
                                                    ],
                                                    [
                                                        -39.098,
                                                        78.885
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 54,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -3.966,
                                                        2.062
                                                    ],
                                                    [
                                                        -6.834,
                                                        6.177
                                                    ],
                                                    [
                                                        -4.687,
                                                        8.038
                                                    ],
                                                    [
                                                        -6.284,
                                                        3.528
                                                    ],
                                                    [
                                                        -17.363,
                                                        -5.997
                                                    ],
                                                    [
                                                        -9.794,
                                                        -5.121
                                                    ],
                                                    [
                                                        -5.603,
                                                        -10.833
                                                    ],
                                                    [
                                                        5.162,
                                                        -9.219
                                                    ],
                                                    [
                                                        12.736,
                                                        -9.547
                                                    ],
                                                    [
                                                        3.115,
                                                        -9.442
                                                    ],
                                                    [
                                                        1.666,
                                                        -5.388
                                                    ],
                                                    [
                                                        21.679,
                                                        5.9
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.195,
                                                        -4.03
                                                    ],
                                                    [
                                                        14.041,
                                                        -12.69
                                                    ],
                                                    [
                                                        8.322,
                                                        -14.271
                                                    ],
                                                    [
                                                        4.758,
                                                        -2.671
                                                    ],
                                                    [
                                                        13.683,
                                                        4.726
                                                    ],
                                                    [
                                                        4.063,
                                                        2.125
                                                    ],
                                                    [
                                                        1.624,
                                                        3.14
                                                    ],
                                                    [
                                                        -4.76,
                                                        8.5
                                                    ],
                                                    [
                                                        -12.605,
                                                        9.448
                                                    ],
                                                    [
                                                        -2.879,
                                                        8.788
                                                    ],
                                                    [
                                                        -6.537,
                                                        21.316
                                                    ],
                                                    [
                                                        -29.128,
                                                        -7.927
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -65.075,
                                                        10.365
                                                    ],
                                                    [
                                                        -36.098,
                                                        -30.115
                                                    ],
                                                    [
                                                        -12.098,
                                                        -50.115
                                                    ],
                                                    [
                                                        -6.098,
                                                        -82.115
                                                    ],
                                                    [
                                                        20.902,
                                                        -71.115
                                                    ],
                                                    [
                                                        46.902,
                                                        -64.115
                                                    ],
                                                    [
                                                        65.902,
                                                        -46.115
                                                    ],
                                                    [
                                                        68.902,
                                                        -21.115
                                                    ],
                                                    [
                                                        42.902,
                                                        -8.115
                                                    ],
                                                    [
                                                        22.125,
                                                        25.885
                                                    ],
                                                    [
                                                        17.173,
                                                        70.633
                                                    ],
                                                    [
                                                        -39.098,
                                                        78.885
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.839,
                                            "y": 0
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -3.966,
                                                        2.062
                                                    ],
                                                    [
                                                        -13.25,
                                                        13.49
                                                    ],
                                                    [
                                                        -4.687,
                                                        8.038
                                                    ],
                                                    [
                                                        -6.284,
                                                        3.528
                                                    ],
                                                    [
                                                        -17.363,
                                                        -5.997
                                                    ],
                                                    [
                                                        -9.794,
                                                        -5.121
                                                    ],
                                                    [
                                                        -5.603,
                                                        -10.833
                                                    ],
                                                    [
                                                        5.162,
                                                        -9.219
                                                    ],
                                                    [
                                                        12.736,
                                                        -9.547
                                                    ],
                                                    [
                                                        -0.871,
                                                        -9.874
                                                    ],
                                                    [
                                                        -0.722,
                                                        -5.574
                                                    ],
                                                    [
                                                        21.679,
                                                        5.9
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -0.413,
                                                        -10.672
                                                    ],
                                                    [
                                                        13.262,
                                                        -13.502
                                                    ],
                                                    [
                                                        8.322,
                                                        -14.271
                                                    ],
                                                    [
                                                        4.758,
                                                        -2.671
                                                    ],
                                                    [
                                                        13.683,
                                                        4.726
                                                    ],
                                                    [
                                                        4.063,
                                                        2.125
                                                    ],
                                                    [
                                                        1.624,
                                                        3.14
                                                    ],
                                                    [
                                                        -4.76,
                                                        8.5
                                                    ],
                                                    [
                                                        -12.605,
                                                        9.448
                                                    ],
                                                    [
                                                        1.133,
                                                        12.317
                                                    ],
                                                    [
                                                        2.727,
                                                        21.14
                                                    ],
                                                    [
                                                        -29.128,
                                                        -7.927
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -60.168,
                                                        15.092
                                                    ],
                                                    [
                                                        -36.098,
                                                        -30.115
                                                    ],
                                                    [
                                                        -12.098,
                                                        -50.115
                                                    ],
                                                    [
                                                        -7.292,
                                                        -78.499
                                                    ],
                                                    [
                                                        20.902,
                                                        -71.115
                                                    ],
                                                    [
                                                        46.902,
                                                        -64.115
                                                    ],
                                                    [
                                                        65.902,
                                                        -46.115
                                                    ],
                                                    [
                                                        68.902,
                                                        -21.115
                                                    ],
                                                    [
                                                        42.902,
                                                        -8.115
                                                    ],
                                                    [
                                                        28.529,
                                                        27.297
                                                    ],
                                                    [
                                                        37.748,
                                                        73.792
                                                    ],
                                                    [
                                                        -39.098,
                                                        78.885
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 135.000005498663,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -3.966,
                                                        2.062
                                                    ],
                                                    [
                                                        -6.834,
                                                        6.177
                                                    ],
                                                    [
                                                        -4.687,
                                                        8.038
                                                    ],
                                                    [
                                                        -6.284,
                                                        3.528
                                                    ],
                                                    [
                                                        -17.363,
                                                        -5.997
                                                    ],
                                                    [
                                                        -9.794,
                                                        -5.121
                                                    ],
                                                    [
                                                        -5.603,
                                                        -10.833
                                                    ],
                                                    [
                                                        5.162,
                                                        -9.219
                                                    ],
                                                    [
                                                        12.736,
                                                        -9.547
                                                    ],
                                                    [
                                                        3.115,
                                                        -9.442
                                                    ],
                                                    [
                                                        1.666,
                                                        -5.388
                                                    ],
                                                    [
                                                        21.679,
                                                        5.9
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        3.195,
                                                        -4.03
                                                    ],
                                                    [
                                                        14.041,
                                                        -12.69
                                                    ],
                                                    [
                                                        8.322,
                                                        -14.271
                                                    ],
                                                    [
                                                        4.758,
                                                        -2.671
                                                    ],
                                                    [
                                                        13.683,
                                                        4.726
                                                    ],
                                                    [
                                                        4.063,
                                                        2.125
                                                    ],
                                                    [
                                                        1.624,
                                                        3.14
                                                    ],
                                                    [
                                                        -4.76,
                                                        8.5
                                                    ],
                                                    [
                                                        -12.605,
                                                        9.448
                                                    ],
                                                    [
                                                        -2.879,
                                                        8.788
                                                    ],
                                                    [
                                                        -6.537,
                                                        21.316
                                                    ],
                                                    [
                                                        -29.128,
                                                        -7.927
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -70.098,
                                                        -1.115
                                                    ],
                                                    [
                                                        -36.098,
                                                        -30.115
                                                    ],
                                                    [
                                                        -12.098,
                                                        -50.115
                                                    ],
                                                    [
                                                        -6.098,
                                                        -82.115
                                                    ],
                                                    [
                                                        20.902,
                                                        -71.115
                                                    ],
                                                    [
                                                        46.902,
                                                        -64.115
                                                    ],
                                                    [
                                                        65.902,
                                                        -46.115
                                                    ],
                                                    [
                                                        68.902,
                                                        -21.115
                                                    ],
                                                    [
                                                        42.902,
                                                        -8.115
                                                    ],
                                                    [
                                                        22.125,
                                                        25.885
                                                    ],
                                                    [
                                                        17.173,
                                                        70.633
                                                    ],
                                                    [
                                                        -39.098,
                                                        78.885
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.698039215686,
                                    0.63137254902,
                                    0.576470588235,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 Hair",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    422.565,
                                    220.591
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "arms/Stretch Outlines 2",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": -0.359,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        379.401,
                        301.419,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        379,
                        302,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            -9,
                                            56
                                        ],
                                        [
                                            14.377,
                                            9.698
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -12.179,
                                            -7.317
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -6,
                                            -5
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -18.146,
                                            -12.24
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.994,
                                            3
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6,
                                            5
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -30.569,
                                            32.842
                                        ],
                                        [
                                            72.398,
                                            -23.181
                                        ],
                                        [
                                            -4.562,
                                            -88.842
                                        ],
                                        [
                                            -48.553,
                                            -36.061
                                        ],
                                        [
                                            4.876,
                                            -15.632
                                        ],
                                        [
                                            -58.602,
                                            12.819
                                        ],
                                        [
                                            -74.596,
                                            29.819
                                        ],
                                        [
                                            -63.119,
                                            27.819
                                        ],
                                        [
                                            -76.602,
                                            48.819
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.929411824544,
                                    0.968627510819,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 dd",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    526.069,
                                    384.658
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "arms/Stretch Outlines",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                -14
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 30,
                            "s": [
                                -5
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                -10
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                -5
                            ]
                        },
                        {
                            "t": 143.000005824509,
                            "s": [
                                -14
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        379,
                        302,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        379,
                        302,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -13,
                                                        0
                                                    ],
                                                    [
                                                        -71.113,
                                                        17.045
                                                    ],
                                                    [
                                                        -10.101,
                                                        -2.02
                                                    ],
                                                    [
                                                        -7,
                                                        0
                                                    ],
                                                    [
                                                        11,
                                                        2.945
                                                    ],
                                                    [
                                                        -12.023,
                                                        13.873
                                                    ],
                                                    [
                                                        14,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        13,
                                                        0
                                                    ],
                                                    [
                                                        6.75,
                                                        -1.618
                                                    ],
                                                    [
                                                        10,
                                                        2
                                                    ],
                                                    [
                                                        7,
                                                        0
                                                    ],
                                                    [
                                                        -11,
                                                        -2.945
                                                    ],
                                                    [
                                                        13,
                                                        -15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -142,
                                                        77.5
                                                    ],
                                                    [
                                                        -156,
                                                        -77.5
                                                    ],
                                                    [
                                                        70.297,
                                                        -83.974
                                                    ],
                                                    [
                                                        96.184,
                                                        -73.929
                                                    ],
                                                    [
                                                        128.184,
                                                        -71.929
                                                    ],
                                                    [
                                                        131.184,
                                                        -46.929
                                                    ],
                                                    [
                                                        95.184,
                                                        -53.929
                                                    ],
                                                    [
                                                        106.184,
                                                        -35.929
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -13,
                                                        0
                                                    ],
                                                    [
                                                        -71.113,
                                                        17.045
                                                    ],
                                                    [
                                                        -10.101,
                                                        -2.02
                                                    ],
                                                    [
                                                        -7,
                                                        0
                                                    ],
                                                    [
                                                        11,
                                                        2.945
                                                    ],
                                                    [
                                                        -12.023,
                                                        13.873
                                                    ],
                                                    [
                                                        14,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        13,
                                                        0
                                                    ],
                                                    [
                                                        6.75,
                                                        -1.618
                                                    ],
                                                    [
                                                        10,
                                                        2
                                                    ],
                                                    [
                                                        7,
                                                        0
                                                    ],
                                                    [
                                                        -11,
                                                        -2.945
                                                    ],
                                                    [
                                                        13,
                                                        -15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -142,
                                                        77.5
                                                    ],
                                                    [
                                                        -140.061,
                                                        -78.894
                                                    ],
                                                    [
                                                        94.523,
                                                        -30.257
                                                    ],
                                                    [
                                                        120.41,
                                                        -20.212
                                                    ],
                                                    [
                                                        152.41,
                                                        -11.962
                                                    ],
                                                    [
                                                        155.41,
                                                        13.038
                                                    ],
                                                    [
                                                        119.41,
                                                        -0.212
                                                    ],
                                                    [
                                                        130.41,
                                                        24.038
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -13,
                                                        0
                                                    ],
                                                    [
                                                        -71.113,
                                                        17.045
                                                    ],
                                                    [
                                                        -10.101,
                                                        -2.02
                                                    ],
                                                    [
                                                        -7,
                                                        0
                                                    ],
                                                    [
                                                        11,
                                                        2.945
                                                    ],
                                                    [
                                                        -12.023,
                                                        13.873
                                                    ],
                                                    [
                                                        14,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        13,
                                                        0
                                                    ],
                                                    [
                                                        6.75,
                                                        -1.618
                                                    ],
                                                    [
                                                        10,
                                                        2
                                                    ],
                                                    [
                                                        7,
                                                        0
                                                    ],
                                                    [
                                                        -11,
                                                        -2.945
                                                    ],
                                                    [
                                                        13,
                                                        -15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -142,
                                                        77.5
                                                    ],
                                                    [
                                                        -140.061,
                                                        -78.894
                                                    ],
                                                    [
                                                        94.523,
                                                        -30.257
                                                    ],
                                                    [
                                                        120.41,
                                                        -20.212
                                                    ],
                                                    [
                                                        152.41,
                                                        -18.212
                                                    ],
                                                    [
                                                        155.41,
                                                        6.788
                                                    ],
                                                    [
                                                        119.41,
                                                        -0.212
                                                    ],
                                                    [
                                                        130.41,
                                                        17.788
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 142.000005783779,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -13,
                                                        0
                                                    ],
                                                    [
                                                        -71.113,
                                                        17.045
                                                    ],
                                                    [
                                                        -10.101,
                                                        -2.02
                                                    ],
                                                    [
                                                        -7,
                                                        0
                                                    ],
                                                    [
                                                        11,
                                                        2.945
                                                    ],
                                                    [
                                                        -12.023,
                                                        13.873
                                                    ],
                                                    [
                                                        14,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        13,
                                                        0
                                                    ],
                                                    [
                                                        6.75,
                                                        -1.618
                                                    ],
                                                    [
                                                        10,
                                                        2
                                                    ],
                                                    [
                                                        7,
                                                        0
                                                    ],
                                                    [
                                                        -11,
                                                        -2.945
                                                    ],
                                                    [
                                                        13,
                                                        -15
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -142,
                                                        77.5
                                                    ],
                                                    [
                                                        -156,
                                                        -77.5
                                                    ],
                                                    [
                                                        70.297,
                                                        -83.974
                                                    ],
                                                    [
                                                        96.184,
                                                        -73.929
                                                    ],
                                                    [
                                                        128.184,
                                                        -71.929
                                                    ],
                                                    [
                                                        131.184,
                                                        -46.929
                                                    ],
                                                    [
                                                        95.184,
                                                        -53.929
                                                    ],
                                                    [
                                                        106.184,
                                                        -35.929
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    408.467,
                                    135.977
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -21.541,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        68.684,
                                                        -58.392
                                                    ],
                                                    [
                                                        -95.5,
                                                        -39.314
                                                    ],
                                                    [
                                                        -73.912,
                                                        39.314
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -21.541,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        92.91,
                                                        -4.675
                                                    ],
                                                    [
                                                        -79.561,
                                                        -40.708
                                                    ],
                                                    [
                                                        -73.912,
                                                        39.314
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -21.541,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        92.91,
                                                        -4.675
                                                    ],
                                                    [
                                                        -79.561,
                                                        -40.708
                                                    ],
                                                    [
                                                        -73.912,
                                                        39.314
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 142.000005783779,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -21.541,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        68.684,
                                                        -58.392
                                                    ],
                                                    [
                                                        -95.5,
                                                        -39.314
                                                    ],
                                                    [
                                                        -73.912,
                                                        39.314
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    403.967,
                                    151.44
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "Shoes/Stretch Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            10.353,
                                            0.416
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            6.003,
                                            -4.419
                                        ],
                                        [
                                            -6.003,
                                            4.003
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    914.774,
                                    902.584
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 8",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -10.353,
                                            0.416
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -6.003,
                                            -4.419
                                        ],
                                        [
                                            6.003,
                                            4.003
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    212.866,
                                    903.084
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -7.175,
                                            6.388
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -12.149,
                                            -5.716
                                        ],
                                        [
                                            12.15,
                                            -0.672
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    233.699,
                                    897.594
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.526,
                                            3.41
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.41,
                                            -0.526
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3.41,
                                            0.525
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.526,
                                            3.41
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -64.422,
                                            20.682
                                        ],
                                        [
                                            -71.548,
                                            15.459
                                        ],
                                        [
                                            -73.76,
                                            1.096
                                        ],
                                        [
                                            -70.965,
                                            0.665
                                        ],
                                        [
                                            71.021,
                                            -21.207
                                        ],
                                        [
                                            73.234,
                                            -6.844
                                        ],
                                        [
                                            68.01,
                                            0.282
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    251.973,
                                    937.844
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.124,
                                            2.401
                                        ],
                                        [
                                            -6.935,
                                            3.66
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -17.516,
                                            10.401
                                        ],
                                        [
                                            -2.804,
                                            3.571
                                        ],
                                        [
                                            -0.304,
                                            -2.681
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.873,
                                            -1.829
                                        ],
                                        [
                                            -3.325,
                                            -7.101
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            7.509,
                                            -4.459
                                        ],
                                        [
                                            1.667,
                                            -2.122
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            75.568,
                                            9.435
                                        ],
                                        [
                                            -66.418,
                                            31.307
                                        ],
                                        [
                                            -72.242,
                                            24.791
                                        ],
                                        [
                                            -65.447,
                                            5.553
                                        ],
                                        [
                                            -25.876,
                                            -15.324
                                        ],
                                        [
                                            0.604,
                                            -29.273
                                        ],
                                        [
                                            49.158,
                                            -16.908
                                        ],
                                        [
                                            63.081,
                                            -29.185
                                        ],
                                        [
                                            68.453,
                                            -27.637
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    247.427,
                                    907.202
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            7.175,
                                            6.388
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            12.15,
                                            -5.716
                                        ],
                                        [
                                            -12.149,
                                            -0.672
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    901.441,
                                    897.594
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.526,
                                            3.41
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -3.41,
                                            -0.526
                                        ]
                                    ],
                                    "o": [
                                        [
                                            3.41,
                                            0.525
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.526,
                                            3.41
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            64.421,
                                            20.682
                                        ],
                                        [
                                            71.547,
                                            15.459
                                        ],
                                        [
                                            73.759,
                                            1.096
                                        ],
                                        [
                                            70.964,
                                            0.665
                                        ],
                                        [
                                            -71.022,
                                            -21.207
                                        ],
                                        [
                                            -73.234,
                                            -6.844
                                        ],
                                        [
                                            -68.011,
                                            0.282
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    883.167,
                                    937.844
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1.124,
                                            2.401
                                        ],
                                        [
                                            6.935,
                                            3.66
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            17.516,
                                            10.401
                                        ],
                                        [
                                            2.804,
                                            3.571
                                        ],
                                        [
                                            0.304,
                                            -2.681
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            2.873,
                                            -1.829
                                        ],
                                        [
                                            3.325,
                                            -7.101
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -7.509,
                                            -4.459
                                        ],
                                        [
                                            -1.667,
                                            -2.122
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -75.568,
                                            9.435
                                        ],
                                        [
                                            66.419,
                                            31.307
                                        ],
                                        [
                                            72.242,
                                            24.791
                                        ],
                                        [
                                            65.448,
                                            5.553
                                        ],
                                        [
                                            25.877,
                                            -15.324
                                        ],
                                        [
                                            -0.604,
                                            -29.273
                                        ],
                                        [
                                            -49.158,
                                            -16.908
                                        ],
                                        [
                                            -63.081,
                                            -29.185
                                        ],
                                        [
                                            -68.453,
                                            -27.637
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    887.714,
                                    907.202
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 7",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "PantsTop/Stretch Outlines",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        366,
                        418,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        366,
                        418,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -12,
                                            -2.5
                                        ],
                                        [
                                            12,
                                            2.5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    368.467,
                                    441.977
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -9.5,
                                            3
                                        ],
                                        [
                                            9.5,
                                            -3
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    365.967,
                                    442.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            380.467,
                                            439.977
                                        ],
                                        [
                                            380.467,
                                            489.977
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            354.467,
                                            439.477
                                        ],
                                        [
                                            354.467,
                                            489.477
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            -2.761
                                        ],
                                        [
                                            2.761,
                                            0
                                        ],
                                        [
                                            0,
                                            2.761
                                        ],
                                        [
                                            -2.761,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            2.761
                                        ],
                                        [
                                            -2.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -2.761
                                        ],
                                        [
                                            2.761,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            5,
                                            0
                                        ],
                                        [
                                            0,
                                            5
                                        ],
                                        [
                                            -5,
                                            0
                                        ],
                                        [
                                            0,
                                            -5
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    380.467,
                                    439.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            -2.761
                                        ],
                                        [
                                            2.761,
                                            0
                                        ],
                                        [
                                            0,
                                            2.761
                                        ],
                                        [
                                            -2.761,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            2.761
                                        ],
                                        [
                                            -2.761,
                                            0
                                        ],
                                        [
                                            0,
                                            -2.761
                                        ],
                                        [
                                            2.761,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            5,
                                            0
                                        ],
                                        [
                                            0,
                                            5
                                        ],
                                        [
                                            -5,
                                            0
                                        ],
                                        [
                                            0,
                                            -5
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    354.467,
                                    439.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 6",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            37.019,
                                            8.007
                                        ],
                                        [
                                            -37.019,
                                            -8.007
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    447.448,
                                    428.47
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 7",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -37,
                                            10
                                        ],
                                        [
                                            37,
                                            -10
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    271.467,
                                    427.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 8",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 8,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.674,
                                            16.118
                                        ],
                                        [
                                            -0.875,
                                            -3.132
                                        ],
                                        [
                                            -12.873,
                                            -2.745
                                        ],
                                        [
                                            -57.463,
                                            -3.609
                                        ],
                                        [
                                            0.701,
                                            0.687
                                        ],
                                        [
                                            18.236,
                                            21.876
                                        ],
                                        [
                                            45.652,
                                            36.847
                                        ],
                                        [
                                            -4,
                                            -17
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -41.848,
                                            -22.218
                                        ],
                                        [
                                            -26.838,
                                            -6.325
                                        ]
                                    ],
                                    "o": [
                                        [
                                            5,
                                            0
                                        ],
                                        [
                                            0.136,
                                            -3.249
                                        ],
                                        [
                                            5.453,
                                            19.52
                                        ],
                                        [
                                            38.914,
                                            8.299
                                        ],
                                        [
                                            0.979,
                                            0.061
                                        ],
                                        [
                                            -14.546,
                                            -14.248
                                        ],
                                        [
                                            -30.714,
                                            13.136
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.524,
                                            -8.52
                                        ],
                                        [
                                            41.848,
                                            22.219
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -14.85,
                                            88.081
                                        ],
                                        [
                                            -2.176,
                                            39.963
                                        ],
                                        [
                                            3.697,
                                            40.561
                                        ],
                                        [
                                            33.652,
                                            87.62
                                        ],
                                        [
                                            169.335,
                                            3.826
                                        ],
                                        [
                                            170.15,
                                            2.026
                                        ],
                                        [
                                            73.15,
                                            -87.919
                                        ],
                                        [
                                            -99.85,
                                            -95.919
                                        ],
                                        [
                                            -166.85,
                                            8.081
                                        ],
                                        [
                                            -166.557,
                                            7.945
                                        ],
                                        [
                                            -82.593,
                                            32.747
                                        ],
                                        [
                                            -15.012,
                                            88.406
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    371.317,
                                    485.396
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 9",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 9,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "Left leg/Stretch Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 30,
                            "s": [
                                -10.436
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                0
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.204
                                ],
                                "y": [
                                    0.998
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 80,
                            "s": [
                                -10.436
                            ]
                        },
                        {
                            "t": 143.000005824509,
                            "s": [
                                0
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        282,
                        884,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        282,
                        884,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -26.773,
                                            6
                                        ],
                                        [
                                            20.922,
                                            -17
                                        ],
                                        [
                                            26.772,
                                            -5.341
                                        ],
                                        [
                                            -19.773,
                                            17
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.937254961799,
                                    0.058823533152,
                                    0.266666666667,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    230.239,
                                    787.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -28.273,
                                            6.5
                                        ],
                                        [
                                            22.422,
                                            -17.5
                                        ],
                                        [
                                            28.272,
                                            -5.841
                                        ],
                                        [
                                            -21.273,
                                            17.5
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0.400000029919,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 sock line left",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    215.739,
                                    761.977
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            69,
                                            77.315
                                        ],
                                        [
                                            -16,
                                            -84.999
                                        ],
                                        [
                                            -69,
                                            -60.685
                                        ],
                                        [
                                            20.915,
                                            84.999
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    243.467,
                                    808.162
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -4.784,
                                                        5.563
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        9.391,
                                                        5.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        5.101,
                                                        -7.887
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.437,
                                                        -5.728
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.568,
                                                        -6.412
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        7.11,
                                                        -8.268
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -8.089,
                                                        -4.774
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.627,
                                                        5.609
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        72.32,
                                                        185.397
                                                    ],
                                                    [
                                                        -25.769,
                                                        -0.713
                                                    ],
                                                    [
                                                        -23.744,
                                                        -20.644
                                                    ],
                                                    [
                                                        163.41,
                                                        -188.749
                                                    ],
                                                    [
                                                        159.033,
                                                        -215.247
                                                    ],
                                                    [
                                                        112.761,
                                                        -249.835
                                                    ],
                                                    [
                                                        89.156,
                                                        -244.264
                                                    ],
                                                    [
                                                        -86.781,
                                                        -31.548
                                                    ],
                                                    [
                                                        -87.092,
                                                        -13.028
                                                    ],
                                                    [
                                                        42.294,
                                                        202.615
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -4.784,
                                                        5.563
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        9.391,
                                                        5.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        5.101,
                                                        -7.887
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.437,
                                                        -5.728
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.568,
                                                        -6.412
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        7.11,
                                                        -8.268
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -8.089,
                                                        -4.774
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.627,
                                                        5.609
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        72.32,
                                                        185.397
                                                    ],
                                                    [
                                                        -15.158,
                                                        13.443
                                                    ],
                                                    [
                                                        -13.133,
                                                        -6.488
                                                    ],
                                                    [
                                                        202.523,
                                                        -147.339
                                                    ],
                                                    [
                                                        198.146,
                                                        -173.837
                                                    ],
                                                    [
                                                        151.874,
                                                        -208.425
                                                    ],
                                                    [
                                                        128.269,
                                                        -202.854
                                                    ],
                                                    [
                                                        -86.781,
                                                        -31.548
                                                    ],
                                                    [
                                                        -87.092,
                                                        -13.028
                                                    ],
                                                    [
                                                        42.294,
                                                        202.615
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 54,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -4.784,
                                                        5.563
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        9.391,
                                                        5.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        5.101,
                                                        -7.887
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.437,
                                                        -5.728
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.568,
                                                        -6.412
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        7.11,
                                                        -8.268
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -8.089,
                                                        -4.774
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.627,
                                                        5.609
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        72.32,
                                                        185.397
                                                    ],
                                                    [
                                                        -25.769,
                                                        -0.713
                                                    ],
                                                    [
                                                        -23.744,
                                                        -20.644
                                                    ],
                                                    [
                                                        163.41,
                                                        -188.749
                                                    ],
                                                    [
                                                        159.033,
                                                        -215.247
                                                    ],
                                                    [
                                                        112.761,
                                                        -249.835
                                                    ],
                                                    [
                                                        89.156,
                                                        -244.264
                                                    ],
                                                    [
                                                        -86.781,
                                                        -31.548
                                                    ],
                                                    [
                                                        -87.092,
                                                        -13.028
                                                    ],
                                                    [
                                                        42.294,
                                                        202.615
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.244,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 80,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -4.784,
                                                        5.563
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        9.391,
                                                        5.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        5.101,
                                                        -7.887
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.437,
                                                        -5.728
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.568,
                                                        -6.412
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        7.11,
                                                        -8.268
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -8.089,
                                                        -4.774
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.627,
                                                        5.609
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        72.32,
                                                        185.397
                                                    ],
                                                    [
                                                        -15.158,
                                                        13.443
                                                    ],
                                                    [
                                                        -13.133,
                                                        -6.488
                                                    ],
                                                    [
                                                        202.523,
                                                        -147.339
                                                    ],
                                                    [
                                                        198.146,
                                                        -173.837
                                                    ],
                                                    [
                                                        151.874,
                                                        -208.425
                                                    ],
                                                    [
                                                        128.269,
                                                        -202.854
                                                    ],
                                                    [
                                                        -86.781,
                                                        -31.548
                                                    ],
                                                    [
                                                        -87.092,
                                                        -13.028
                                                    ],
                                                    [
                                                        42.294,
                                                        202.615
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 143.000005824509,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -4.784,
                                                        5.563
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        9.391,
                                                        5.543
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        5.101,
                                                        -7.887
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.437,
                                                        -5.728
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.568,
                                                        -6.412
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        7.11,
                                                        -8.268
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -8.089,
                                                        -4.774
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        -3.627,
                                                        5.609
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ],
                                                    [
                                                        0,
                                                        0
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        72.32,
                                                        185.397
                                                    ],
                                                    [
                                                        -25.769,
                                                        -0.713
                                                    ],
                                                    [
                                                        -23.744,
                                                        -20.644
                                                    ],
                                                    [
                                                        163.41,
                                                        -188.749
                                                    ],
                                                    [
                                                        159.033,
                                                        -215.247
                                                    ],
                                                    [
                                                        112.761,
                                                        -249.835
                                                    ],
                                                    [
                                                        89.156,
                                                        -244.264
                                                    ],
                                                    [
                                                        -86.781,
                                                        -31.548
                                                    ],
                                                    [
                                                        -87.092,
                                                        -13.028
                                                    ],
                                                    [
                                                        42.294,
                                                        202.615
                                                    ]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.929411824544,
                                    0.968627510819,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 yy",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    229.173,
                                    691.862
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "RightLeg/Stretch Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                2
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 30.235,
                            "s": [
                                -2.21
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 54,
                            "s": [
                                2
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.317
                                ],
                                "y": [
                                    1.003
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "t": 81,
                            "s": [
                                -2.21
                            ]
                        },
                        {
                            "t": 143.000005824509,
                            "s": [
                                2
                            ]
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        862,
                        886,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        862,
                        886,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -23.966,
                                            13.694
                                        ],
                                        [
                                            14.979,
                                            -22.183
                                        ],
                                        [
                                            23.966,
                                            -12.729
                                        ],
                                        [
                                            -14.07,
                                            22.183
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.937254961799,
                                    0.058823533152,
                                    0.266666666667,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    773.355,
                                    800.902
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -25.256,
                                            14.609
                                        ],
                                        [
                                            16.268,
                                            -23.097
                                        ],
                                        [
                                            25.256,
                                            -13.643
                                        ],
                                        [
                                            -15.36,
                                            23.098
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0.400000029919,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 sock line right",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    752.066,
                                    780.721
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            21.634,
                                            48.724
                                        ],
                                        [
                                            -93.601,
                                            -49.758
                                        ],
                                        [
                                            -49.963,
                                            -88.435
                                        ],
                                        [
                                            93.601,
                                            59.701
                                        ],
                                        [
                                            51.388,
                                            88.436
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    801.866,
                                    828.776
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1,
                                            -10
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            8.5,
                                            -3
                                        ],
                                        [
                                            -8.5,
                                            5
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    622.967,
                                    647.477
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -73.18,
                                            -80.753
                                        ],
                                        [
                                            -45.723,
                                            -29.529
                                        ],
                                        [
                                            5.478,
                                            -1.004
                                        ],
                                        [
                                            5.706,
                                            9.408
                                        ],
                                        [
                                            82.878,
                                            83.392
                                        ],
                                        [
                                            28.469,
                                            38.401
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            81.493,
                                            89.926
                                        ],
                                        [
                                            4.678,
                                            3.021
                                        ],
                                        [
                                            -20.47,
                                            3.751
                                        ],
                                        [
                                            -32.252,
                                            -53.187
                                        ],
                                        [
                                            -49.726,
                                            -50.036
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -149.045,
                                            -196.471
                                        ],
                                        [
                                            -15.14,
                                            -44.718
                                        ],
                                        [
                                            209.014,
                                            176.758
                                        ],
                                        [
                                            206.747,
                                            187.987
                                        ],
                                        [
                                            163.308,
                                            187.062
                                        ],
                                        [
                                            -63.48,
                                            -14.195
                                        ],
                                        [
                                            -213.692,
                                            -140.938
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.929411824544,
                                    0.968627510819,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1  uu",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    663.159,
                                    690.415
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 5",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "PantsBottom/Stretch Outlines",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        374,
                        420,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        374,
                        420,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            8.497,
                                            26.46
                                        ],
                                        [
                                            1,
                                            6.729
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            21,
                                            40
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -1,
                                            -6.73
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            71.5,
                                            -36.5
                                        ],
                                        [
                                            -66.997,
                                            47.04
                                        ],
                                        [
                                            -91.5,
                                            -1.77
                                        ],
                                        [
                                            25.5,
                                            -73.5
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 3,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.639215686275,
                                    0.819607902976,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 right inside shorts",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    471.967,
                                    525.977
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            4.293,
                                            -10.135
                                        ],
                                        [
                                            -41.848,
                                            -22.219
                                        ],
                                        [
                                            -4.524,
                                            8.521
                                        ],
                                        [
                                            4,
                                            20.143
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -3.763,
                                            8.883
                                        ],
                                        [
                                            41.848,
                                            22.218
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -4,
                                            -20.142
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -81.972,
                                            -20.895
                                        ],
                                        [
                                            -14.391,
                                            34.763
                                        ],
                                        [
                                            69.573,
                                            59.565
                                        ],
                                        [
                                            81.735,
                                            -5.618
                                        ],
                                        [
                                            -43.956,
                                            -68.086
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 5,
                                "ix": 5
                            },
                            "lc": 3,
                            "lj": 1,
                            "ml": 10,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.639215686275,
                                    0.819607902976,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 left inside shorts",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    286.732,
                                    514.237
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "Bg/Stretch Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            -35.158,
                                            35.691
                                        ],
                                        [
                                            30.958,
                                            64.302
                                        ],
                                        [
                                            40.797,
                                            63.318
                                        ],
                                        [
                                            9.761,
                                            87.799
                                        ],
                                        [
                                            126.318,
                                            53.749
                                        ],
                                        [
                                            9.264,
                                            -127.294
                                        ],
                                        [
                                            -4.899,
                                            -156.356
                                        ],
                                        [
                                            -21.104,
                                            -119.386
                                        ],
                                        [
                                            -68.361,
                                            -28.215
                                        ],
                                        [
                                            -185.609,
                                            -1.511
                                        ]
                                    ],
                                    "o": [
                                        [
                                            40.784,
                                            -41.402
                                        ],
                                        [
                                            -30.623,
                                            -63.604
                                        ],
                                        [
                                            -43.137,
                                            -66.95
                                        ],
                                        [
                                            -14.609,
                                            -131.392
                                        ],
                                        [
                                            -146.754,
                                            -62.444
                                        ],
                                        [
                                            -8.411,
                                            115.568
                                        ],
                                        [
                                            4.068,
                                            129.861
                                        ],
                                        [
                                            14.103,
                                            79.777
                                        ],
                                        [
                                            104.957,
                                            43.322
                                        ],
                                        [
                                            82.863,
                                            0.674
                                        ]
                                    ],
                                    "v": [
                                        [
                                            330.539,
                                            414.852
                                        ],
                                        [
                                            347.326,
                                            216.176
                                        ],
                                        [
                                            229.513,
                                            98.011
                                        ],
                                        [
                                            195.529,
                                            -117.666
                                        ],
                                        [
                                            -23.48,
                                            -467.663
                                        ],
                                        [
                                            -369.872,
                                            -299.158
                                        ],
                                        [
                                            -227.468,
                                            21.983
                                        ],
                                        [
                                            -300.758,
                                            307.296
                                        ],
                                        [
                                            -177.332,
                                            465.324
                                        ],
                                        [
                                            172.248,
                                            426.906
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.929411824544,
                                    0.968627510819,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1 åå",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    482.956,
                                    500.248
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 11,
            "ty": 1,
            "nm": "White Solid 3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        500,
                        500,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "sw": 1000,
            "sh": 1000,
            "sc": "#ffffff",
            "ip": 0,
            "op": 1798.00007323404,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}